import { css } from '@emotion/react';

const container = css`
  background-color: var(--saa-primary-color-10);
  height: calc(100% - 60px);
`;

export default {
  container,
};
